<div
  class="container-fluid d-flex flex-column align-content-center justify-content-center"
>
  <router-outlet></router-outlet>
  <footer class="py-5">
    <div class="container">
      <div class="row align-items-center justify-content-xl-between">
        <div class="col-12">
          <div class="copyright text-center text-muted">
            &copy; {{ date | date: 'yyyy' }}
            <a href="https://www.limitlesscare.com/" class="font-weight-bold ml-1 " target="_blank"
              >Limitless Care Portal</a
            >
          </div>
        </div>
      </div>
    </div>
  </footer>
</div>
